import { useEffect, useState } from "react";

import UserDetails from "../components/UserDetails";
import { daDK } from "@mui/x-date-pickers/locales";
import { toast } from "react-toastify";
import {
  create_user,
  login_user,
  Change_password_manager,
} from "../reduxData/auth/authAction";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { get_users } from "../reduxData/user/userAction";

import { useSelector } from "react-redux";
import EmptyData from "../components/EmptyData";
import moment from "moment";
import CustomPagination from "../components/CustomPagination";
import CustomModal from "./Type/CustomModal";
import PasswordCustomModel from "./Products/Latest/Hooks/PasswordCustomModel";
import Input from "@mui/joy/Input";
import AddStoreManager from "./Model/AddStoreManager";
import { getCountryCallingCode } from "react-phone-number-input";

const StoreMangment = () => {
  const { allUsers, totalUsers } = useSelector((state) => state.user);

  const [country, setCountry] = useState("AE");

  const [total, setTotal] = useState("");
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const [showModal, setShowMoal] = useState(false);
  const [type,setType] = useState("");
  const [show, setShow] = useState(false);
  const [data, setData] = useState(null);
  const [showPassword, setNoShowPassword] = useState(false);
  const [showPasswordConfirm, setNoShowPasswordConfirm] = useState(false);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentTab, setCurrentTab] = useState("store-manager");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [isDelete, setIsDelete] = useState(false);
  const [statusFilter, setStatusFilter] = useState("All");
  const [resetPage, setResetPage] = useState(false);
  const [open, setOpen] = useState(false);
  const [passworChanger, setPasswordChanger] = useState(false);
  const [newpassword, setNewpassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordData, setPasswordData] = useState(null);
  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      fetchData();
    }, 500);
    return () => {
      clearTimeout(handler);
    };
  }, [name]);

  const handlePasswordChange = async (data) => {
    console.log("Password change data:", data);
    if (!newpassword || !confirmPassword) {
      toast.error("Password and Confirm Password are required");
      return;
    }
    if (newpassword !== confirmPassword) {
      toast.error("Password and Confirm Password do not match");
      return;
    }
    try {
      const payload = {
        new_password: newpassword,
        // confirm_password: confirmPassword
      };
      const reponse = await Change_password_manager(
        dispatch,
        token,
        data?.id,
        payload
      );
      if (reponse?.status) {
        setPasswordChanger(false);
      }
    } catch (error) {
      // console.error("Error updating password:", error);
    }
  };

  const changeDOJFormat = (data) => {
    const joinDate = moment(data).format("MM/DD/YYYY");
    return joinDate;
  };

  const fetchData = async (page = currentPage, rows = perPage) => {
    try {
      const data = await get_users(
        dispatch,
        token,
        page,
        rows,
        name,
        statusFilter,
        currentTab
      );
      setTotal(data?.length);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const handleModalClose = () => {
    setPasswordChanger(false);
  };

  return (
    <>
      {showModal && (
        <AddStoreManager showModal={showModal} setShowMoal={setShowMoal} type={type}/>
      )}

      <div className="container">
        <div className="d-flex align-items-center justify-content-between my-2">
          <h3 className="mb-0 fw-600 ">
            {" "}
            Store Management ({allUsers?.length})
          </h3>
          <button
            onClick={() =>{ setShowMoal(true);setType("Add")} }
            className="btn common-button text-capitalize"
          >
            Add Store Manager
          </button>
        </div>

        <PasswordCustomModel
          open={passworChanger}
          setOpen={handleModalClose}
          inputAttribute={newpassword}
          setInputAttribute={setNewpassword}
          setConfirmPassword={setConfirmPassword}
          confPasswor={confirmPassword}
          // handleAddAttribute={updatePassword}
          // onSubmit={handlePasswordChange}
          onSubmit={() => handlePasswordChange(passwordData)}
          label="password"
          placeholder="Enter New Password"
          data={passwordData}
        />
        <div className="filters mb-3 w-100">
          <Input
            id="nameInput"
            type="text"
            placeholder="Search by name/email"
            value={name}
            onChange={async (e) => {
              setName(e.target.value);
            }}
          />
        </div>

        <div>
          <div className="table-responsive">
            <table className="table user-management-table table-hover">
              <thead className="border-gray">
                <th scope="col">Sr. No.</th>
                <th scope="col">Name</th>
                <th scope="col">Email</th>
                <th scope="col">Phone No.</th>
                <th scope="col" className="text-center">
                  Date of Joining
                </th>
                <th scope="col" className="text-center">
                  Status
                </th>
                <th scope="col" className="text-center ">
                  Change Password
                </th>
                {/* <th scope="col" className="text-center">
                  Action
                </th> */}
              </thead>
              <tbody>
                {Array.isArray(allUsers) && allUsers?.length > 0 ? (
                  allUsers.map((data, index) => (
                    <tr key={index}>
                      <td>{index + 1}.</td>
                      <td>
                        <div
                          className={
                            data?.user_name
                              ? "pointer w-fit-content cursor-pointer hover-underline"
                              : "pointer"
                          }
                          onClick={() => {
                            setShow(true);
                            setData(data);
                          }}
                        >
                          {data?.user_name ? data?.user_name : "N/A"}
                        </div>
                      </td>
                      <td>{data?.email}</td>
                      <td>{data?.phone_no ? `+${data?.country_code  && getCountryCallingCode(data?.country_code)} ${data?.phone_no}` : "N/A"}</td>
                      <td className="text-center">
                        {changeDOJFormat(data.createdAt)}
                      </td>
                      <td className="text-center">
                        {data?.is_deactive ? "In-active" : "Active"}
                      </td>
                      <td className="text-center">
                        <button
                          onClick={() => {
                            // updatePassword(data?.id)
                            setPasswordChanger(true);
                            setPasswordData(data);
                          }}
                          className="btn btn-primary "
                        >
                          Change
                        </button>
                      </td>
                      {/* <td>
                        <Link
                          className="navbar-brand mx-2"
                          // to={`/editUser/${data.id} `}
                           onClick={() => {setShowMoal(true);setType("Edit")}}
                        >
                          <i className="far fa-edit edit"></i>
                        </Link>
                      </td> */}
                    </tr>
                  ))
                ) : (
                  <EmptyData />
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="mt-3">
          {total > 0 && (
            <CustomPagination
              total={total}
              onPageChange={async (page, perPage) => {
                await get_users(
                  dispatch,
                  localStorage.getItem("token"),
                  page,
                  perPage,
                  "",
                  statusFilter,
                  currentTab
                );
              }}
            />
          )}

          <UserDetails
            show={show}
            handleClose={() => {
              setData(null);
              setShow(false);
            }}
            user={data}
          />
        </div>
      </div>
    </>
  );
};
export default StoreMangment;
